export enum CardOfferingType {
  PHYSICAL = "PHYSICAL",
  DIGITAL = "DIGITAL"
}
